$ = window.$ = window.jQuery = require('jquery/dist/jquery')
const MarkerClusterer = require('@google/markerclusterer').default

const GoogleMap = {
  CustomMarker: null,
  xhr: false,
  xhrLocation: false,
  xhrAutocomplete: false,

  oms: null,
  clusterer: null,
  holders: [],
  holder: null,
  markers: [],
  bounds: null,
  defaultImage: '/_resources/themes/dakkapel/images/icons/marker.png',
  markerImage: '/_resources/themes/dakkapel/images/icons/marker.png',
  darkImage: '/_resources/themes/dakkapel/images/icons/marker.png',
  alternativeImage: '/_resources/themes/dakkapel/images/ico-home-dakkapellen.svg',
  highlightImage: '/_resources/themes/dakkapel/images/icons/marker-active.png',
  closeIcon: '/_resources/themes/dakkapel/images/icons/close-icon.png',
  markerPath: '/_resources/themes/dakkapel/images/icons/markers/m',
  clusterMarker: '/_resources/themes/dakkapel/images/icons/markers/m1.png',
  clusterMarker2: '/_resources/themes/dakkapel/images/icons/markers/m4.png',
  clusterMarker3: '/_resources/themes/dakkapel/images/icons/markers/m5.png',
  mapOptions: {},
  infoWindow: null,
  autocomplete: null,
  place: null,

  boot: function () {
    if (!GoogleMap.CustomMarker) {
      GoogleMap.CustomMarker = require('./custom-marker')
    }

    GoogleMap.locationCompleter();

    if ($('[data-needs-map="true"]:visible').length > 0) {
      $('[data-needs-map="true"]:visible').each(function (i, o) {
        google.maps.Map.prototype.setCenterWithOffset = function (
            latlng,
            offsetX,
            offsetY,
            pan
        ) {
          let map = this
          let ov = new google.maps.OverlayView()
          ov.onAdd = function () {
            let proj = this.getProjection()
            let aPoint = proj.fromLatLngToContainerPixel(latlng)
            aPoint.x = aPoint.x + offsetX
            aPoint.y = aPoint.y + offsetY
            if (pan) {
              map.panTo(proj.fromContainerPixelToLatLng(aPoint))
            } else {
              map.setCenter(proj.fromContainerPixelToLatLng(aPoint))
            }
          }
          ov.draw = function () {
          }
          ov.setMap(this)
        }

        GoogleMap.initMap($(o))
      })
    }
  },

  /**
   * Cancel all xhr requests
   */
  cancelRequests: function () {
    if (
        GoogleMap.xhr &&
        GoogleMap.xhr !== false &&
        GoogleMap.xhr.readystate !== 4
    ) {
      GoogleMap.xhr.abort();
    }
  },

  misclick: function ($holder) {
    // Dakkapel.$data.browserOpen = false
  },

  initMap: function ($element) {
    let $center

    if ($element.data('center-lat') && $element.data('center-lon')) {
      $center = new google.maps.LatLng(
          $element.data('center-lat'),
          $element.data('center-lon')
      )
    } else {
      $center = new google.maps.LatLng(52.54115008736168, 4.850669160351568)
    }

    this.mapOptions = {
      mapTypeControl: false,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      panControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      zoomControl: !Modernizr.touch,
      // streetViewControl: false,
      center: $center,
      zoom: 8,
      gestureHandling: 'cooperative'
    }

    if ($element.data('dark')) {
      this.markerImage = this.darkImage;
      this.mapOptions.styles = this.mapStyle
      this.mapOptions.scrollwheel = false
    } else {
      this.markerImage = this.defaultImage;
    }

    $element.attr('data-needs-map', 'false')

    let $holder = {
      element: $element,
      map: new google.maps.Map($element.eq(0)[0], this.mapOptions),
      index: this.holders.length,
      bounds: [],
      markers: []
    }

    let streetview = $holder.map.get('streetView')
    if (streetview) {
      // update streetview options
      streetview.setOptions({
        addressControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        panControl: false
      })
    }

    $holder.bounds = new google.maps.LatLngBounds()
    this.infoWindow = new google.maps.InfoWindow()

    if ($element.data('use-json')) {
      let markerList = $('input[name="' + $element.data('use-json') + '"]')
      let markersFromDom = markerList.data('markers')
      let image = new google.maps.MarkerImage(this.markerImage, null, null, null, new google.maps.Size(32, 32));

      const markers = markersFromDom.map((location, i) => {
        $holder.bounds.extend(new google.maps.LatLng(location.lat, location.lng))
        let marker = new google.maps.Marker({
          id: location.id,
          position: location,
          map: $holder.map,
          icon: image
        });

        google.maps.event.addListener(marker, 'click', function () {
          GoogleMap.loadDetails([marker])
        })

        return marker;
      });

      if (markers && markers.length > 0) {
        this.clusterer = new MarkerClusterer($holder.map, markers, {
          imagePath: this.markerPath,
          maxZoom: 30,
          zoomOnClick: true,
          gridSize: 45,
          styles:  [
            {
              width: 32,
              height: 32,
              url: this.clusterMarker3,
              textColor: 'white',
              textSize: 16,
            },
            {
              width: 44,
              height: 44,
              url: this.clusterMarker2,
              textColor: 'white',
              textSize: 20,
            },
            {
              width: 56,
              height: 56,
              url: this.clusterMarker,
              textColor: 'white',
              textSize: 24,
            },
          ]
          //     [
          //   {
          //     textColor: 'white',
          //     textSize: '22',
          //     // url: this.clusterMarker,
          //     // height: 52,
          //     // width: 52
          //   }
          // ]
        })
      }
    } else if ($element.data('center-marker')) {
      GoogleMap.appendMarker(
          $holder,
          {},
          $center.lat(),
          $center.lng()
      )
    }

    if ($element.data('my-lat') && $element.data('my-lon')) {
      GoogleMap.appendMarker(
          $holder,
          {},
          $element.data('my-lat'),
          $element.data('my-lon'),
          true
      )
    }

    if ($element.data('use-local')) {
      if (window.localStorage.getItem('location_lat') && window.localStorage.getItem('location_lon')) {
        $center = new google.maps.LatLng(window.localStorage.getItem('location_lat'), window.localStorage.getItem('location_lon'))
        GoogleMap.appendMarker(
            $holder,
            {},
            window.localStorage.getItem('location_lat'),
            window.localStorage.getItem('location_lon'),
            window.localStorage.getItem('location_lon'),
            true
        )
      }
    }

    if ($element.data('fit')) {
      google.maps.event.addListenerOnce(
          $holder.map,
          'projection_changed',
          function () {
            GoogleMap.fitMap($holder, 12)
          }
      )
    } else {
      if ($element.data('use-local')) {
        $holder.map.setZoom(14)
      } else {
        $holder.map.setZoom(12)
      }
      $holder.map.panTo($center)
    }

    // https://googlemaps.github.io/js-marker-clusterer/docs/reference.html
    if (!$element.data('default-clustering')) {
      google.maps.event.addListener($holder.map, 'clusterclick', function (cluster) {

        let clusterMarkers = cluster.getMarkers()
        if (clusterMarkers.length >= 2) {
          let diffLat = Math.abs(cluster.getBounds().getSouthWest().lat() - cluster.getBounds().getNorthEast().lat())
          let diffLng = Math.abs(cluster.getBounds().getSouthWest().lng() - cluster.getBounds().getNorthEast().lng())

          if ($holder.map.getZoom() >= 16 || (diffLat === 0 && diffLng === 0)) {
            // no need to zoom anymore
            GoogleMap.closeInfoBoxes($holder)
            GoogleMap.loadDetails(clusterMarkers)
          } else if (diffLat > 0 || diffLng > 0) {

          }
        } else {
          GoogleMap.loadDetails(clusterMarkers)
        }
      })
    }

    // close infowindow on 'misclick'
    if (!Modernizr.touch) {
      google.maps.event.addListener($holder.map, 'click', function () {
        GoogleMap.misclick($holder)
      })
    }
    this.holders.push($holder)
  },

  getHolderFromElement: function ($element) {
    let found = false;
    $.each(GoogleMap.holders, function (i, o) {
      if (o.element[0] == $element[0]) {
        found = o;
      }
    })
    return found;
  },

  clearOverlays: function ($holder) {
    if ($holder.markers) {
      for (let i = 0; i < $holder.markers.length; i++) {
        $holder.markers[i].setMap(null)
      }
      $holder.markers.length = 0
      $holder.bounds.bounds = new google.maps.LatLngBounds()
    }
  },

  appendNumberedMarker: function ($holder, lat, lon, number, details) {
    let image = this.clusterMarker
    let markerPosition = new google.maps.LatLng(lat, lon)
    let markerOptions = {
      position: markerPosition,
      map: $holder.map,
      icon: image,
      label: {
        color: 'white',
        text: number.toString(),
        fontSize: '22px'
      },
      details: details,
    }

    $holder.bounds.extend(markerOptions.position)

    let marker = new google.maps.Marker(markerOptions)
    $holder.markers.push(marker)

    // if (details) {
    //   let infoBoxOptions = GoogleMap.infoBoxTemplate(details.agenda_id)
    //   let ib = infoBoxOptions.infoBox
    //   marker.infobox = ib
    //
    //   // add marker to map
    //   $holder.markers.push(marker)
    //   $holder.bounds.extend(marker.position)
    //
    //   if ($holder.element.data('use-json')) {
    //     GoogleMap.clusterer.addMarker(marker, true)
    //   }
    //
    //   google.maps.event.addListener(marker, 'click', function () {
    //     GoogleMap.closeInfoBoxes($holder)
    //     GoogleMap.loadDetails([marker])
    //   })
    //
    // }
    return true
  },

  /**
   * Post the Marker IDs to the backend and get the rendered HTML
   *
   * @param markers
   */
  loadDetails: function (markers) {
    let formData = new FormData();

    let index = 0
    $.each(markers, function (mi, marker) {
      formData.append('items[' + index + ']', marker.id);
      index++
    })

    Dakkapel.loadMapResults(formData);
  },

  appendMarker: function ($holder, details, lat, lon, alternativeImage) {
    let image = this.markerImage
    let customizedMarker = false

    if (alternativeImage) {
      image = new google.maps.MarkerImage(this.alternativeImage, null, null, null, new google.maps.Size(16, 16));
    }

    // alternative image set on map-div
    if ($holder && $holder.element.data('marker-image')) {
      customizedMarker = true
      image = $holder.element.data('marker-image')
    }

    let markerPosition = new google.maps.LatLng(lat, lon)
    let markerOptions = {
      position: markerPosition,
      map: $holder.map,
      icon: image,
      details: details,
    }

    if (alternativeImage) {
      markerOptions.optimized = false;
      markerOptions.zIndex = 99;
    }

    $holder.bounds.extend(markerOptions.position)

    if (customizedMarker) {
      new CustomMarker(markerOptions)
      return true
    }

    let marker = new google.maps.Marker(markerOptions)
    $holder.markers.push(marker)

    if (!alternativeImage) {
      google.maps.event.addListener(marker, 'click', function () {
        GoogleMap.loadDetails([marker])
      })
    }

    return true

  },

  sourceTemplate: function (dataID) {
    return $('.original-templates .item__listing[data-id="' + dataID + '"]')
  },

  newTemplate: function (sourceElement) {
    let newTemplate = sourceElement
        .clone()
        .wrapInner('<div class="item__listing" data-id="' + sourceElement.data('id') + '" />')
    newTemplate.find('.trainer__info--pricing .ico').removeClass('black')
    //newTemplate.find('.trainer__name').wrapInner('<a href="' + sourceElement.attr('href') + '" />')
    return newTemplate
  },

  infoBoxTemplate: function (dataID) {
    let ibOptions = {
      disableAutoPan: false,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(-140, 0),
      zIndex: null,
      boxStyle: {
        padding: '0px 0px 0px 0px',
        width: '360px',
        // height: "40px"
      },
      closeBoxURL: this.closeIcon,
      infoBoxClearance: new google.maps.Size(1, 1),
      isHidden: false,
      pane: 'floatPane',
      enableEventPropagation: false
    }

    let sourceElement = GoogleMap.sourceTemplate(dataID)
    let newTemplate = GoogleMap.newTemplate(sourceElement)
    let source = newTemplate.html()
    ibOptions.content = source

    let ib = new InfoBox(ibOptions)

    return {
      sourceElement: sourceElement,
      infoBoxOptions: ibOptions,
      infoBox: ib,
      source: source
    }
  },

  fitMap: function ($holder, zoom, center) {
    if (zoom && center) {
      $holder.map.setZoom(zoom)
      $holder.map.setCenter(new google.maps.LatLng(center.lat, center.lng))
    } else {
      $holder.map.fitBounds($holder.bounds)

      // if (zoom && $holder.map.getZoom() > 12) {
      //   $holder.map.setZoom(zoom)
      // } else {
      //   $holder.map.setZoom($holder.map.getZoom() - 1)
      // }
    }
  },

  closeInfoBoxes: function ($holder) {
    $.each($holder.markers, function (i2, savedMarker) {
      $('.item__listing.shown').removeClass('shown')
      if (savedMarker.infobox) {
        //savedMarker.setIcon(GoogleMap.markerImage);
        savedMarker.infobox.close()
      }
    })
  },

  openInfoBox: function ($holder, marker) {
    if (marker.infobox) {
      marker.infobox.open($holder.map, marker)
      $holder.map.setCenterWithOffset(
          marker.infobox.getPosition(),
          -100,
          100,
          true
      )
    }

    $.each($holder.markers, function (i, savedMarker) {
      if (savedMarker !== marker && savedMarker.infobox) {
        //savedMarker.setIcon(GoogleMap.markerImage);
        savedMarker.infobox.close()
      }
    })
  },

  locationCompleter: function () {
    let input = $('#locationComplete')
    if (input.length === 1) {
      let $form = input.closest('form')

      // check for change since page load
      input.data('default', input.val())
      input.on('change keyup keydown', function (e) {
        if (input.val() != '') {
          input.closest('.autocompletion').removeClass('empty-error')
        }

        if (input.val() != input.data('default')) {
          $form.find('input[name="changed"]').prop('value', 'true')
        } else {
          $form.find('input[name="changed"]').prop('value', 'false')
        }
      })

      $form.on('submit', function (e) {
        e.preventDefault()
        return false
      })

      // // do not use type="submit"; button click is triggered too on enter keypress!!
      // $form.find('button[data-submit]').on('click', function (e) {
      //   e.preventDefault()
      //   GoogleMap.fauxSubmit()
      // })

      input.on('keydown', function (event) {
        let suggestion_selected = $('.pac-item-selected').length > 0
        if (event.which === 13 && !suggestion_selected) {
          GoogleMap.fauxSubmit()
        }
      })

      GoogleMap.autocomplete = new google.maps.places.Autocomplete(input[0], {types: '(cities)'});
      GoogleMap.autocomplete.setComponentRestrictions({
        country: ['nl']
      })
      GoogleMap.autocomplete.addListener(
          'place_changed',
          GoogleMap.placeChanged
      )
    }
  },

  /**
   * Fake submit function
   */
  fauxSubmit: function () {
    let input = $('#locationComplete')
    if (input.data('instant') && (!input.val() || input.val() === '')) {
      $('.autocompletion').addClass('error empty-error')
    } else {
      $('.autocompletion').removeClass('error empty-error')
      if ($('.pac-item-selected').length === 0) {
        GoogleMap.getFirstPrediction()
      } else {
        console.log('pac selected detected, autocomplete should trigger')
      }
    }
  },

  /**
   * Not clicked on a prediction, but hit enter / submit
   * Get the first prediction and redirect to the result
   */
  getFirstPrediction: function () {
    Core.startLoader()
    let input = $('#locationComplete')
    let query = input.val()
    if ($('.pac-item').length > 0) {
      query = $('.pac-item .pac-item-query')
          .eq(0)
          .text()
    }

    let service = new google.maps.places.AutocompleteService()
    service.getPlacePredictions({
      input: query,
      types: ['(cities)']
    }, function (
        predictions,
        status
    ) {
      switch (status) {
        case google.maps.places.PlacesServiceStatus.ZERO_RESULTS:
          GoogleMap.autocompleteNotify('ZERO_RESULTS')
          Core.stopLoader()
          return
        case google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT:
        case google.maps.places.PlacesServiceStatus.REQUEST_DENIED:
        case google.maps.places.PlacesServiceStatus.INVALID_REQUEST:
        case google.maps.places.PlacesServiceStatus.UNKNOWN_ERROR:
        case google.maps.places.PlacesServiceStatus.ERROR:
          Core.toastError(status)
          Core.stopLoader()
          return
        case google.maps.places.PlacesServiceStatus.OK:
        default:
          break
      }

      // Take the first result
      input.prop('value', predictions[0].description).trigger('change')
      $('input[name="lat"],input[name="lon"]').prop('value', '')

      let placesService = new google.maps.places.PlacesService(input[0]);
      placesService.getDetails(
        {'reference': predictions[0].reference},
        function detailsresult(detailsResult, placesServiceStatus) {
          GoogleMap.autocomplete.set('place', detailsResult)
        }
      );

    })
  },

  /**
   * After google autocomplete
   */
  placeChanged: function () {
    if (GoogleMap.autocomplete) {
      GoogleMap.place = GoogleMap.autocomplete.getPlace()
      if (GoogleMap.place && GoogleMap.place.geometry) {
        $('#locationComplete').data('autocomplete-filled', true)
        let locality = null
        $.each(GoogleMap.place.address_components, function (i, component) {
          if (!locality) {
            $.each(component.types, function (ic, type) {
              if (!locality) {
                if ('locality' === type) {
                  locality = component.short_name
                }
              }
            })
          }
        })

        window.localStorage.setItem('location_locality', locality)
        window.localStorage.setItem('location_name', GoogleMap.place.name)
        window.localStorage.setItem('location_vicinity', GoogleMap.place.vicinity)
        window.localStorage.setItem('location_formatted', GoogleMap.place.formatted_address)
        window.localStorage.setItem('location_lat', GoogleMap.place.geometry.location.lat())
        window.localStorage.setItem('location_lon', GoogleMap.place.geometry.location.lng())

        let mapNameID = $('#locationComplete').closest('form').data('map');
        if (mapNameID) {
          let $holder = GoogleMap.getHolderFromElement($(mapNameID))
          if ($holder) {
            $holder.map.setCenter(new google.maps.LatLng(window.localStorage.getItem('location_lat'), window.localStorage.getItem('location_lon')))
            $holder.map.setZoom(14)
            GoogleMap.appendMarker(
                $holder,
                {},
                window.localStorage.getItem('location_lat'),
                window.localStorage.getItem('location_lon'),
                true
            )

          }
        }

      }
    }
  },

  mapStyle: [
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#6195a0'
        }
      ]
    },
    {
      featureType: 'administrative.province',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [
        {
          lightness: '0'
        },
        {
          saturation: '0'
        },
        {
          color: '#f5f5f2'
        },
        {
          gamma: '1'
        }
      ]
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [
        {
          lightness: '-3'
        },
        {
          gamma: '1.00'
        }
      ]
    },
    {
      featureType: 'landscape.natural.terrain',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#bae5ce'
        },
        {
          visibility: 'on'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: 45
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fac9a9'
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text',
      stylers: [
        {
          color: '#4e4e4e'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#787878'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'transit.station.airport',
      elementType: 'labels.icon',
      stylers: [
        {
          hue: '#0a00ff'
        },
        {
          saturation: '-77'
        },
        {
          gamma: '0.57'
        },
        {
          lightness: '0'
        }
      ]
    },
    {
      featureType: 'transit.station.rail',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#43321e'
        }
      ]
    },
    {
      featureType: 'transit.station.rail',
      elementType: 'labels.icon',
      stylers: [
        {
          hue: '#ff6c00'
        },
        {
          lightness: '4'
        },
        {
          gamma: '0.75'
        },
        {
          saturation: '-68'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#eaf6f8'
        },
        {
          visibility: 'on'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#c7eced'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          lightness: '-49'
        },
        {
          saturation: '-53'
        },
        {
          gamma: '0.79'
        }
      ]
    }
  ]
}

export default GoogleMap
